import React from "react";
import { Card, CardContent, Divider, Stack, Typography } from "@mui/material";

const SectionCard = ({
    title,
    description,
    action,
    children,
    padded = true,
    dense = false,
    sx,
}) => {
    const hasHeader = Boolean(title || action);

    return (
        <Card sx={sx}>
            {hasHeader && (
                <>
                    <Stack
                        direction={{ xs: "column", sm: "row" }}
                        alignItems={{ xs: "flex-start", sm: "center" }}
                        justifyContent="space-between"
                        spacing={1.5}
                        sx={{ p: dense ? 2 : 3, pb: dense ? 1.5 : 2 }}
                    >
                        <div>
                            {title && <Typography variant="h6">{title}</Typography>}
                            {description && (
                                <Typography
                                    variant="body2"
                                    color="text.secondary"
                                    sx={{ mt: 0.5 }}
                                >
                                    {description}
                                </Typography>
                            )}
                        </div>
                        {action}
                    </Stack>
                    <Divider />
                </>
            )}
            {padded ? (
                <CardContent sx={{ p: dense ? 2 : 3, "&:last-child": { pb: dense ? 2 : 3 } }}>
                    {children}
                </CardContent>
            ) : (
                children
            )}
        </Card>
    );
};

export default SectionCard;